module.exports = __webpack_public_path__ + "03_glasses_red.290cb9ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer4/03_glasses_red.png
// module id = AuSq
// module chunks = 0